// Mock trigger words data
export const mockTriggerWords = [
  {
    id: "tw-1",
    trigger: "как вернуть",
    template_text: "Добрый день! По вопросам возврата рекомендуем обратиться в службу поддержки маркетплейса. Они помогут оформить возврат согласно правилам площадки. С уважением, {brand}",
    priority: 90,
    require_rag: false,
    is_active: true,
    created_at: "2025-10-15T10:00:00Z",
  },
  {
    id: "tw-2",
    trigger: "возврат денег",
    template_text: "Добрый день! Возврат средств оформляется через службу поддержки маркетплейса. Мы сожалеем, что товар не оправдал ваших ожиданий. С уважением, {brand}",
    priority: 90,
    require_rag: false,
    is_active: true,
    created_at: "2025-10-15T10:00:00Z",
  },
  {
    id: "tw-3",
    trigger: "какой тон",
    template_text: "Добрый день! Для подбора оттенка рекомендуем учитывать тон вашей кожи. {rag_context} Будем рады помочь с выбором! С любовью, {brand}",
    priority: 70,
    require_rag: true,
    is_active: true,
    created_at: "2025-10-15T10:00:00Z",
  },
  {
    id: "tw-4",
    trigger: "состав",
    template_text: "Добрый день! Состав нашей продукции указан на упаковке и в описании на сайте маркетплейса. {rag_context} С уважением, {brand}",
    priority: 60,
    require_rag: true,
    is_active: true,
    created_at: "2025-10-15T10:00:00Z",
  },
  {
    id: "tw-5",
    trigger: "когда появится",
    template_text: "Добрый день! Информацию о наличии товара и сроках поступления уточняйте на странице товара или в службе поддержки маркетплейса. С уважением, {brand}",
    priority: 50,
    require_rag: false,
    is_active: true,
    created_at: "2025-10-15T10:00:00Z",
  },
];
